import { useId } from "react";
import { Button } from "@/shared/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/ui/dialog";
import type { CategoryAttributeResponse } from "@/services/api";

interface ValuesModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  attribute: CategoryAttributeResponse | null;
}

export function ValuesModal({
  open,
  onOpenChange,
  attribute,
}: ValuesModalProps) {
  const values = attribute?.values || [];
  const sortedValues = [...values].sort((a, b) => a.order - b.order);
  const descriptionId = useId();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-[600px]"
        aria-describedby={descriptionId}
      >
        <DialogHeader>
          <DialogTitle>Values for "{attribute?.name}"</DialogTitle>
          <DialogDescription>
            View all values associated with this attribute.
          </DialogDescription>
        </DialogHeader>
        <div className="max-h-[400px] overflow-y-auto">
          {sortedValues.length > 0 ? (
            <div className="space-y-2">
              {sortedValues.map((value) => (
                <div
                  key={String(value.id)}
                  className="rounded-lg border border-grid-200 bg-white p-4"
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <span className="flex h-8 w-8 items-center justify-center rounded-full bg-grid-100 text-sm font-medium text-ink-600">
                        {value.order}
                      </span>
                      <div>
                        <h4 className="font-medium text-ink-900">
                          {value.value}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="py-8 text-center text-sm text-ink-500">
              No values attached to this attribute.
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
